import {
    exhaustMap,
    interval,
    isObservable,
    last,
    lastValueFrom,
    map,
    mergeMap,
    Observable,
    share,
    startWith,
    takeWhile,
} from 'rxjs';
import { FetchResponse, TaskParams } from './';
import { operators } from 'ajv/dist/compile/codegen';
import { AbstractTask } from './AbstractTask';

export class PromiseTask extends AbstractTask {
    readonly promise: Promise<any>;
    private resolve: any;
    private reject: any;

    constructor(params: TaskParams) {
        super(params);
        this.promise = new Promise((resolve, reject) => {
            this.resolve = resolve;
            this.reject = reject;
        });
    }

    public startPolling(poolingInterval: number, maxRetry: number, startAfterInterval = false) {
        let operators = [
            startAfterInterval ? undefined : startWith(0),
            takeWhile(() => !this.cancelled),
            exhaustMap(() => this.poll()),
            mergeMap(async (status) => {
                try {
                    let asyncResponse = this.isCompleted(status);
                    let promise = isObservable(asyncResponse) ? lastValueFrom(asyncResponse) : asyncResponse;
                    let completed = await promise;
                    if (completed) {
                        return { status, continuePoll: false };
                    }
                } catch (e) {
                    if (!this.tolerateError) {
                        throw e;
                    }
                }
                if (this.poolCount >= maxRetry) {
                    throw `maximum ${maxRetry} retries reached`;
                }
                return { status, continuePoll: true };
            }),
            takeWhile(({ status, continuePoll }) => continuePoll, true),
            map(({ status, continuePoll }) => status),
            last(),
        ];
        operators = operators.filter((operator) => !!operator);
        // @ts-ignore
        const observable = interval(poolingInterval).pipe(...operators);
        let lastPromise = lastValueFrom(observable);
        lastPromise.then(this.resolve, this.reject);
        return lastPromise;
    }
}
